import { NSARouterMakerResult } from 'namirasoft-account-react';
import { UserFullRow } from 'namirasoft-password';
import { Component } from 'react';
import { EntryTabPageView } from '../EntryTabPageView';
import { PasswordEntities } from '../PasswordEntities';
import { PasswordLayout } from '../PasswordLayout';
import { PasswordRouterProps } from '../PasswordRouterProps';

export interface EntryViewPageProps extends NSARouterMakerResult, PasswordRouterProps
{
    user: UserFullRow;
}

class EntryViewPage extends Component<EntryViewPageProps>
{
    override render()
    {
        return (
            <PasswordLayout
                {...this.props}
                pages={{
                    entity: PasswordEntities.entry(this.props),
                    view: {
                        ui: {
                            tab_page_view: EntryTabPageView.getTabPage(this.props)
                        }
                    }
                }}
            >
                <></>
            </PasswordLayout>
        )
    }
}

export default EntryViewPage